import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import Login from '../pages/auth/LoginPage';
import NotSupportPage from '../pages/NotSupportPage';
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  // const quotationReviewRegex = new RegExp();
  if (
    (/Mobile/.test(window.navigator.userAgent) || window.innerWidth < 1100) &&
    !pathname.match('^/dashboard/quotation/approving/.*$')
  ) {
    return <NotSupportPage />;
  }

  if (
    !/Mobile/.test(window.navigator.userAgent) &&
    pathname.match('^/dashboard/quotation/approving/.*$')
  ) {
    return <Navigate to={`/dashboard/quotation/${pathname.split('/')[4]}/profile`} />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}
